import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * Webhook source types.
 * - stripe: Stripe payment webhooks
 * - revenuecat: RevenueCat subscription webhooks
 * - github: GitHub App deliveries, keyed by `x-github-delivery` (OL-98)
 *
 * The `source` column is a plain varchar, so admitting a new source is a
 * TS-only change — no migration and no enum-value isolation (M6).
 */
export const WebhookSource = Schema.Literal("stripe", "revenuecat", "github");
export type WebhookSource = Schema.Schema.Type<typeof WebhookSource>;

/**
 * WebhookEvent model for idempotency tracking.
 *
 * Tracks processed webhook events to ensure exactly-once processing.
 * Events are marked as processing when received, then marked as
 * processed with a timestamp when handling completes.
 *
 * @since 1.0.0
 */
export class WebhookEvent extends Model.Class<WebhookEvent>("WebhookEvent")({
  id: Model.Generated(Schema.String),
  source: WebhookSource,
  externalId: Schema.String,
  eventType: Schema.String,
  stripeCustomerId: Schema.NullOr(Schema.String),
  processedAt: Schema.NullOr(Schema.DateTimeUtc),
  createdAt: Model.DateTimeInsertFromDate,
}) {}
